import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import { connect } from 'react-redux';

import {
  APIgetFilesGroup,
  APIgetFilesGroupFiles,
} from '../../api/Files';

import UploadPageFileGrid from './FileGrid';

import {
  datePrefix,
  getFormattedDateTime,
} from '../../helpers/DateTime';

import Loading from '../Loading';

const UploadPageFiles = ({
  uploadPage,
  uploadUuid,
}) => {
  const [files, setFiles] = useState([]);
  const [fileGroup, setFileGroup] = useState(null);
  const [page, setPage] = useState(1);
  const [end, setEnd] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setFileGroup(null);
    APIgetFilesGroup(uploadUuid).then((response) => {
      const { data } = response;
      setFileGroup(data);
    });
  }, [uploadUuid]);

  useEffect(() => {
    if (end) {
      return;
    }

    setLoading(true);
    APIgetFilesGroupFiles(uploadUuid, {
      page,
      upload_page_uuid: uploadPage.uuid,
    }).then((response) => {
      const { data } = response;
      if (page === 1) {
        setFiles(data.data);
      } else {
        setFiles(prevFiles => [...prevFiles, ...data.data]);
      }
      if (data.meta.current_page >= data.meta.last_page) {
        setEnd(true);
      }
    }).catch(() => {
      setFiles([]);
      setEnd(true);
    }).finally(() => {
      setLoading(false);
    });
  }, [uploadUuid, uploadPage, page, end]);

  return (
    <div>
      {fileGroup && (
        <div className="upload-files-title center">
          {`${fileGroup.total_files} ${fileGroup.name.toLowerCase()} ${datePrefix()}${getFormattedDateTime(fileGroup.created_at)}`}
        </div>
      )}
      <UploadPageFileGrid
        submittedFiles={files}
        selectedFiles={[]}
        saving={true}
      />
      {loading ? (
        <Loading />
      ) : (
        <Waypoint
          bottomOffset="-50px"
          onEnter={() => { setPage(page + 1); }}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  uploadPage: state.UploadPages.uploadPage,
});

UploadPageFiles.propTypes = {
  uploadPage: PropTypes.object.isRequired,
  uploadUuid: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(UploadPageFiles);
